"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEngagementSearch = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackEngagementSearch(searchTerm) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'Search',
        eventAction: 'Submit',
        eventLabel: searchTerm,
    });
}
exports.trackEngagementSearch = trackEngagementSearch;
//# sourceMappingURL=trackEngagementSearch.js.map